const baseUrl = `${process.env.REACT_APP_API_HOST}api/`;

export default class Routes {
    static training = baseUrl + 'training/';
    static user = baseUrl + 'user/';
    static users = baseUrl + 'users/';
    static allUsers = baseUrl + 'users/all/';
    static person = baseUrl + 'person/';
    static personDocuments = this.person + 'documents/';
    static sections = baseUrl + 'sections/'
    static course = baseUrl + 'course/'
}